export default "__VITE_ASSET__B1sUwStg__"